// extracted by mini-css-extract-plugin
export var circle = "_2q-2";
export var icon = "_2q-a";
export var iconHighlight = "_2q-0";
export var lg = "_2q-8";
export var md = "_2q-7";
export var outline = "_2q-4";
export var sm = "_2q-6";
export var square = "_2q-1";
export var xl = "_2q-9";
export var xs = "_2q-5";
export var xxs = "_2q-3";